// corporateTravel.js

const corporateTravel = {
  id: 6,
  title: "Corporate Travel",
  questions: [
    {
      question: "Do you manage corporate travel bookings?",
      answer:
        "Yes, we handle corporate flights, hotels, transfers, conferences, and employee travel management.",
    },
    {
      question: "Can you arrange business travel on short notice?",
      answer:
        "Yes, our team specializes in quick and efficient last-minute corporate travel arrangements.",
    },
    {
      question: "Do you provide GST invoices?",
      answer:
        "Yes, proper GST invoices and corporate billing support are provided.",
    },
  ],
};

export default corporateTravel;